/**
 * Why the Vault refused a file's CONTENT — the reason a `VAULT_CONTENT_REJECTED`
 * refusal carries in its `data.reason`, so a client can say what to do in the
 * reader's language instead of echoing the server's English sentence.
 * (`apps/platform-api/src/modules/secondary/vault/vault-content.ts` decides it.)
 */
export const VAULT_CONTENT_REJECTION_REASONS = [
  /** This section does not accept files of that type. */
  'mime_not_allowed',
  /** The bytes match no known file type. */
  'unidentifiable',
  /** The file claims one type and contains another. */
  'declared_mime_mismatch',
] as const;

export type VaultContentRejectionReason = (typeof VAULT_CONTENT_REJECTION_REASONS)[number];

export function isVaultContentRejectionReason(
  value: unknown
): value is VaultContentRejectionReason {
  return (
    typeof value === 'string' &&
    (VAULT_CONTENT_REJECTION_REASONS as readonly string[]).includes(value)
  );
}
